export enum FieldStatus {
  completed = 'completed',
  incompleted = 'incompleted',
  error = 'error',
}
